// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2JZme","actions":"GroupTable_actions__1lqJY","deleteModalFooter":"GroupTable_deleteModalFooter__9omIG"};